export const removeHTMLTags = (str: string): string =>
  str.replaceAll(/<[^>]*>/g, '').trim();

export const removeNewLines = (str: string): string =>
  str.replaceAll(/\n/gm, '');
export const removeHTMLTagsAndLines = (str: string): string =>
  removeHTMLTags(str).replaceAll(/\n/gm, '');

/** Any HTML tags on a getter that resolves to a string are stripped.
 * For properties that are themselves objects, a new proxy is returned */
export const createSanitizedProxy = <T extends Record<string, unknown>>(
  obj: T,
) =>
  new Proxy(obj, {
    get(target, prop: string): T[keyof T] {
      const val = target[prop] as T[keyof T];
      if (typeof val === 'string') {
        return removeHTMLTags(val) as T[keyof T];
      }
      if (val !== null && typeof val === 'object') {
        return createSanitizedProxy(
          val as Record<string, unknown>,
        ) as T[keyof T];
      }
      return val;
    },
  });
